import React, { useState } from 'react';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { DataProvider } from './contexts/DataContext';

import LoginModal from './components/Auth/LoginModal';
import NotificationContainer from './components/Layout/NotificationContainer';
import LoadingOverlay from './components/Layout/LoadingOverlay';

import Dashboard from './pages/Dashboard';

import './styles/main.css';

// ===== Composant AppContent =====
const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  const [loadingOverlay, setLoadingOverlay] = useState(false);

  if (isLoading) {
    return <LoadingOverlay show={true} />;
  }

  return (
    <>
      {}
      <LoginModal show={!isAuthenticated} />

      {}
      {isAuthenticated && (
        <div className="app-layout">
          <Dashboard
            onShowLoading={setLoadingOverlay}
          />
        </div>
      )}

      {}
      <LoadingOverlay show={loadingOverlay} />
      <NotificationContainer />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <NotificationProvider>
          <AppContent />
        </NotificationProvider>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
